<app-context-menu #freezeMenu></app-context-menu>

<ng-container *ngIf="inlineMode; else expansionPanel">
  <ng-container *ngTemplateOutlet="columnListContent"></ng-container>
</ng-container>

<ng-template #expansionPanel>
  <mat-expansion-panel class="column-hider-list-expansion-panel" [expanded]="expanded">
    <mat-expansion-panel-header>
      <mat-panel-title style="display: flex; flex-direction: row; gap: 2px; align-items: center; justify-content: flex-start;">
        <mat-icon svgIcon="view_column"></mat-icon>
        <span>{{ 'column_visibility' | translate }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <div class="cols-sets-view-wrapper" *ngIf="setModeNull$ | async">
        <button type="button" class="cascade-select" [matMenuTriggerFor]="setsMenu" [disabled]="!hasColumnSets">
          <span>{{ 'select' | translate }}</span>
          <i class="pi pi-chevron-down"></i>
        </button>
        <mat-menu #setsMenu="matMenu" class="cols-sets-menu">
          <ng-container *ngFor="let group of availableSetsOfColums">
            <ng-container *ngIf="group.options.length > 0">
              <button mat-menu-item [matMenuTriggerFor]="groupMenu">{{ group.name }}</button>
              <mat-menu #groupMenu="matMenu" class="cols-sets-menu">
                <button mat-menu-item *ngFor="let opt of group.options"
                  (click)="handleSetOfColumsChange(opt)">{{ opt.name }}</button>
              </mat-menu>
            </ng-container>
          </ng-container>
        </mat-menu>
        <button type="button" class="btn" (click)="handleAddForUser()" matTooltip="{{'add-for-private-use' | translate | capitalizeFirst }}">
          <i class="pi pi-user-plus"></i>
        </button>
        <button type="button" class="btn" (click)="handleAddGeneral()" matTooltip="{{'add-for-general-use' | translate | capitalizeFirst }}">
          <i class="pi pi-plus"></i>
        </button>
      </div>

      <form [formGroup]="setForm" (ngSubmit)="handleSaveSetSelection()" *ngIf="setModeNotNull$ | async" class="form-colums-wrapper">
        <input type="text" pInputText formControlName="name" placeholder="{{ 'cols-set-name' | translate | capitalizeFirst }}..."
          style="flex: 1; font-size: 15px; line-height: 28px;" />

        <button type="button" class="btn clear" (click)="handleResetSetSelection()">
          <i class="pi pi-times"></i>
        </button>

        <button type="submit" class="btn save" [ngClass]="isSetFormDisabled() ? 'disabled' : ''" [disabled]="isSetFormDisabled()">
          <i class="pi pi-save"></i>
        </button>

        <button type="button" class="btn clear" *ngIf="(setMode | async)?.type === 'EDIT'" (click)="handleDeleteSet()">
          <i class="pi pi-trash"></i>
        </button>
      </form>

      <ng-container *ngTemplateOutlet="columnListContent"></ng-container>
    </ng-template>
  </mat-expansion-panel>
</ng-template>

<ng-template #columnListContent>
  <div class="column-list-wrapper">
    <div class="col-vis-search">
      <i class="pi pi-search col-vis-search-icon"></i>
      <input type="text" [(ngModel)]="searchTerm"
        [placeholder]="'table-nav.search-col' | translate"
        class="col-vis-search-input"
        (click)="$event.stopPropagation()"
        (keydown)="onSearchKeyDown($event)" />
      <i class="pi pi-times cursor-pointer col-vis-search-clear"
        *ngIf="searchTerm"
        (click)="searchTerm = ''"></i>
    </div>
    <form [formGroup]="visabilityForm" style="width: calc(100% - 1px);">
      <mat-list cdkDropList (cdkDropListDropped)="drop($event)">
        <div *ngIf="freezeDividerVisible" class="freeze-divider" [class.freeze-divider-dragging]="freezeDividerDragging"
          [style.top.px]="freezeDividerTop" (mousedown)="startFreezeDividerDrag($event)"
          (contextmenu)="openFreezeMenuFromDivider($event)"></div>
        <ng-container *ngFor="let control of visabilityForm.controls; let idx = index">
          <mat-list-item [formGroupName]="idx" class="mat-list-item"
            [class.hidden-col]="!visabilityForm.at(idx).get(FORM_KEYS.IS_VISIBLE).value"
            [class.search-hidden]="!matchesSearch(idx)"
            [class.frozen-col-item]="isFrozenItem(idx)" cdkDrag [cdkDragDisabled]="!!searchTerm.trim()"
            (contextmenu)="openFreezeMenu($event, idx)"
            (cdkDragStarted)="draggingChange.emit(true)" (cdkDragEnded)="draggingChange.emit(false)">
            <mat-icon *ngIf="!searchTerm.trim()" class="drag-handle" cdkDragHandle svgIcon="drag_indicator"></mat-icon>
            <span class="col-number">{{ getVisibleNumber(idx) }}</span>
            <mat-checkbox class="check-box" color="primary" formControlName="{{FORM_KEYS.IS_VISIBLE}}">
              {{ getColumnLabel(idx) | translate | capitalizeFirst }}
            </mat-checkbox>
          </mat-list-item>
        </ng-container>
        <div class="search-spacer" [style.height.px]="searchSpacerHeight"></div>
      </mat-list>
    </form>

  </div>

  <div *ngIf="!inlineMode" class="mt-1 choose-all-button" (click)="toggleAllChecked()">
    {{ (isAllChecked() ? 'uncheck_all' : 'check_all') | translate | capitalizeFirst }}
  </div>

  <div class="no-columns-alert"
    *ngIf="!inlineMode || visabilityForm.errors?.anyTrueValue"
    [class.no-columns-alert-hidden]="!visabilityForm.errors?.anyTrueValue">
    <mat-icon class="no-columns-alert-icon" svgIcon="warning"></mat-icon>
    <span class="no-columns-alert-label">{{ "no_columns_selected" | translate | capitalizeFirst }}</span>
  </div>
</ng-template>